import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  insertEmailChangeEmail,
  verificationEmailChangeEmail,
} from './change-email-thunk';
import {
  ChangeEmailState,
  EmailNotEditableType,
  StepsChangeEmail,
} from './change-email-type';

const initialState: ChangeEmailState = {
  email: '',
  confirmNewEmail: '',
  insertEmailChangeEmailRequestStatus: 'idle',

  verificationEmailChangeEmailRequestStatus: 'idle',
  step: 'INSERIMENTO_DATI',

  openDialogChangeEmail: false,
  changeEmailVerificationCodeEmail: '',
  emailAlreadyVerificated: false,
  emailAttempts: 0,
  changeEmailVerificationCodePhoneNumber: '',
  phoneNumberAttempts: 0,
  countdown: '',
};

const changeEmailSlice = createSlice({
  name: 'features/change-email',
  initialState,
  reducers: {
    //reset state ChangeEmail
    resetChangeEmailState(state) {
      state.email = '';
      state.confirmNewEmail = '';
      state.insertEmailChangeEmailRequestStatus = 'idle';
      state.changeEmailVerificationCodeEmail = '';
      state.changeEmailVerificationCodePhoneNumber = '';
      state.emailAttempts = 0;
      state.phoneNumberAttempts = 0;
      state.verificationEmailChangeEmailRequestStatus = 'idle';
      state.step = 'INSERIMENTO_DATI';
      state.openDialogChangeEmail = false;
      state.emailAlreadyVerificated = false;
    },
    //Insert Email
    resetInsertEmailChangeEmailRequestState(state) {
      state.insertEmailChangeEmailError = undefined;
      state.insertEmailChangeEmailRequestStatus = 'idle';
    },
    clearInsertEmailChangeEmailError(state) {
      state.insertEmailChangeEmailError = undefined;
      state.insertEmailChangeEmailRequestStatus = 'idle';
    },
    setEmailChangeEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setConfirmNewEmailChangeEmail(state, action: PayloadAction<string>) {
      state.confirmNewEmail = action.payload;
    },
    //Verification Email
    resetVerificationEmailChangeEmailRequestState(state) {
      state.verificationEmailChangeEmailError = undefined;
      state.verificationEmailChangeEmailRequestStatus = 'idle';
    },
    clearVerificationEmailChangeEmailError(state) {
      state.verificationEmailChangeEmailError = undefined;
      state.verificationEmailChangeEmailRequestStatus = 'idle';
    },
    setVerificationEmailChangeEmailCode(state, action: PayloadAction<string>) {
      state.changeEmailVerificationCodeEmail = action.payload;
    },
    //*** */
    setVerificationPhoneNumberCodeChangeEmailCode(
      state,
      action: PayloadAction<string>
    ) {
      state.changeEmailVerificationCodePhoneNumber = action.payload;
    },
    //*** */
    clearVerificationEmailFields(state) {
      state.changeEmailVerificationCodeEmail = '';
    },
    // Update step
    updateStepChangeEmail(state, action: PayloadAction<StepsChangeEmail>) {
      state.step = action.payload;
    },
    updateEmailAlreadyVerificated(state, action: PayloadAction<boolean>) {
      state.emailAlreadyVerificated = action.payload;
    },
    // Open/Close Dialog
    updateOpenDialogChangeEmail(state, action: PayloadAction<boolean>) {
      state.openDialogChangeEmail = action.payload;
    },
    // Open error email not editable
    updateErrorEmailNotEditable(
      state,
      action: PayloadAction<EmailNotEditableType>
    ) {
      state.errorEmailNotEditable = action.payload;
    },
    updateCountdownEmail(state, action: PayloadAction<string>) {
      state.countdown = action.payload;
    },
  },
  extraReducers: (builder) => {
    //Insert Email
    builder.addCase(insertEmailChangeEmail.pending, (state) => {
      state.insertEmailChangeEmailRequestStatus = 'loading';
    });
    builder.addCase(insertEmailChangeEmail.fulfilled, (state, action) => {
      state.endtimeCountdown = action.payload.timeoutOTP;
      state.insertEmailChangeEmailRequestStatus = 'succeeded';
    });
    builder.addCase(insertEmailChangeEmail.rejected, (state, action) => {
      state.insertEmailChangeEmailError = action.payload;
      state.insertEmailChangeEmailRequestStatus = 'failed';
    });
    //Verification Email
    builder.addCase(verificationEmailChangeEmail.pending, (state) => {
      state.verificationEmailChangeEmailRequestStatus = 'loading';
    });
    builder.addCase(verificationEmailChangeEmail.fulfilled, (state) => {
      state.verificationEmailChangeEmailRequestStatus = 'succeeded';
    });
    builder.addCase(verificationEmailChangeEmail.rejected, (state, action) => {
      state.verificationEmailChangeEmailError = action.payload;
      if (
        action.payload.type === 'CODICE_DI_VERIFICA_SBAGLIATO' ||
        action.payload.type === 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO' ||
        action.payload.type === 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO'
      ) {
        state.emailAttempts = action.payload.attemptsEmail;
        state.phoneNumberAttempts = action.payload.attemptsPhoneNumber;
      }
      state.verificationEmailChangeEmailRequestStatus = 'failed';
    });
  },
});

export const {
  resetChangeEmailState,
  resetInsertEmailChangeEmailRequestState,
  clearInsertEmailChangeEmailError,
  setEmailChangeEmail,
  setConfirmNewEmailChangeEmail,
  resetVerificationEmailChangeEmailRequestState,
  clearVerificationEmailChangeEmailError,
  setVerificationEmailChangeEmailCode,
  setVerificationPhoneNumberCodeChangeEmailCode,
  updateStepChangeEmail,
  updateOpenDialogChangeEmail,
  updateErrorEmailNotEditable,
  updateEmailAlreadyVerificated,
  updateCountdownEmail,
} = changeEmailSlice.actions;

export default changeEmailSlice.reducer;
